/** Named trading-hours presets for the form. */
export const HOURS_PRESETS = [
    { id: 'always', label: '24/7 (crypto)', hours: { always: true } },
    { id: 'forex', label: 'Forex 24/5', hours: { tz: 'America/New_York', sessions: [{ days: [0, 1, 2, 3, 4], open: '17:00', close: '17:00' }] } },
    { id: 'futures', label: 'CFD futures hours (Sun–Fri, NY)', hours: { tz: 'America/New_York', sessions: [{ days: [0, 1, 2, 3, 4], open: '18:00', close: '17:00' }] } },
    { id: 'nyse', label: 'US stocks (NYSE / NASDAQ)', hours: { tz: 'America/New_York', sessions: [{ days: [1, 2, 3, 4, 5], open: '09:30', close: '16:00' }] } },
    { id: 'europe', label: 'Europe (Frankfurt)', hours: { tz: 'Europe/Berlin', sessions: [{ days: [1, 2, 3, 4, 5], open: '01:15', close: '22:00' }] } },
    { id: 'london', label: 'London', hours: { tz: 'Europe/London', sessions: [{ days: [1, 2, 3, 4, 5], open: '01:00', close: '21:00' }] } },
    {
        id: 'hongkong',
        label: 'Hong Kong',
        hours: { tz: 'Asia/Hong_Kong', sessions: [{ days: [1, 2, 3, 4, 5], open: '09:15', close: '12:00' }, { days: [1, 2, 3, 4, 5], open: '13:00', close: '16:30' }] },
    },
    {
        id: 'sydney',
        label: 'Sydney',
        hours: { tz: 'Australia/Sydney', sessions: [{ days: [1, 2, 3, 4, 5], open: '09:50', close: '16:30' }, { days: [1, 2, 3, 4], open: '17:10', close: '07:00' }] },
    },
    { id: 'singapore', label: 'Singapore', hours: { tz: 'Asia/Singapore', sessions: [{ days: [1, 2, 3, 4, 5], open: '09:00', close: '17:00' }] } },
];
export const hoursPresetOf = (h) => HOURS_PRESETS.find((p) => JSON.stringify(p.hours) === JSON.stringify(h))?.id ?? 'custom';
//# sourceMappingURL=instrument-search.js.map